import { eachL, go, map, sumBy, takeAll, zipL } from "fxjs/es";
import paper from "paper";
import * as StackBlur from "stackblur-canvas";
import {
  checkPathsCollision,
  getPaperPathsCollisionResults,
} from "./path_collision_check.js";
import { getTranslateCoordsToSnapContainerSimpler } from "./path_snap.js";

export const addEventHitTest = (paper_scope) => {
  const tool = new paper_scope.Tool();

  const hit_opts = {
    segments: true,
    stroke: true,
    fill: true,
    tolerance:
      ((paper_scope.view.size.width + paper_scope.view.size.height) / 2) * 0.01,
  };
  const hit_down = {};

  tool.onMouseDown = (e) => {
    const hit_result = paper_scope.project.activeLayer.hitTest(
      e.point,
      hit_opts
    );
    hit_down.result = hit_result;
    hit_down.type = hit_result && hit_result.type;
    hit_down.path = hit_result && hit_result.item;
  };

  tool.onMouseDrag = (e) => {
    if (hit_down.path && hit_down.path.name !== "container_path") {
      hit_down.path.translate(e.delta);
      getPaperPathsCollisionResults(
        paper_scope.project.activeLayer.children,
        true,
        false
      );
    }
  };

  tool.onMouseUp = () => {
    if (hit_down.path && hit_down.path.name !== "container_path") {
      // const translate_delta = getTranslateCoordsToSnapContainer(
      //   container_path.pathData,
      //   hit_down.path.pathData,
      //   "M482,721v-43h210"
      //   // 4,
      //   // false,
      //   // false
      // );
      // <path id="container" d="M100,100h700v800h-700z" stroke="#000" fill="#fff"/>
      // <path id="forbidden" d="M500,800h300v100h-300z" stroke="#000" fill="#fff"/>
      const container_area_pos = {
        x: 100,
        y: 100,
        w: 700,
        h: 800,
      };
      const forbidden_area_pos = {
        x: 500,
        y: 800,
        w: 300,
        h: 100,
      };
      const translate_delta = getTranslateCoordsToSnapContainerSimpler(
        container_area_pos,
        forbidden_area_pos,
        hit_down.path.pathData,
        true,
        false
      );

      if (translate_delta?.x || translate_delta?.y) {
        hit_down.path.translate(translate_delta);
      }
      getPaperPathsCollisionResults(
        paper_scope.project.activeLayer.children,
        true,
        true
      );
    }
  };
};

export const canvasEvent = (paper_scope) => {
  const tool = new paper_scope.Tool();
  const hit_opts = {
    segments: true,
    stroke: true,
    fill: true,
    tolerance:
      ((paper_scope.view.size.width + paper_scope.view.size.height) / 2) * 0.01,
  };
  const hit_down = {};
  const hit_move = {};
  tool.onMouseDown = (e) => {
    const hit_result = paper_scope.project.activeLayer.hitTest(
      e.point,
      hit_opts
    );
    hit_down.result = hit_result;
    hit_down.type = hit_result && hit_result.type;
    hit_down.path = hit_result && hit_result.item;
    // console.log(hit_down.type, hit_down.path, hit_down.result);
    if (hit_down.type === "segment") {
      if (e.modifiers.shift) {
        hit_down.result.segment.remove();
        // console.log(hit_down.result.segment);
      }
    }
  };
  tool.onMouseMove = (e) => {
    const hit_result = paper_scope.project.hitTest(e.point, hit_opts);
    hit_move.result = hit_result;
    hit_move.type = hit_result && hit_result.type;
    hit_move.path = hit_result && hit_result.item;
    if (hit_move.type === "segment") {
      // console.log(hit_move.result.segment.index);
    }
  };
  tool.onMouseDrag = (e) => {
    if (hit_down.type === "segment") {
      hit_down.result.segment.point = hit_down.result.segment.point.add(
        e.delta
      );
      // hit_down.path.smooth();
    }
  };
};

export const removeChildren = (node) => {
  while (node.firstChild) {
    node.removeChild(node.firstChild);
  }
};

export const makePaperProject = (
  paper_scope,
  width,
  height,
  view_el = null
) => {
  const canvas = document.createElement("canvas");
  canvas.setAttribute("hidpi", "off");
  if (width) canvas.width = width;
  if (height) canvas.height = height;
  if (view_el) {
    paper_scope.settings.handleSize = 6;
    view_el.appendChild(canvas);
  } else {
    canvas.style.display = "none";
  }
  paper_scope.setup(canvas);
};

export const getTime = () => performance.now();

export const consoleTime = (msg, t0, t1) => {
  const dt = Math.round(t1 - t0);
  console.log(msg, dt, "ms");
  return dt;
};

export const binarizeImageData = (data, binarize_threshold = 0.01) => {
  for (let i = 0; i < data.length; i += 4) {
    const alpha = data[i + 3] / 255; // alpha 값을 0-1 범위로 정규화

    // alpha 채널은 유지
    if (alpha > binarize_threshold) {
      data[i] = 0; // R
      data[i + 1] = 0; // G
      data[i + 2] = 0; // B
      data[i + 3] = 255; // A
    } else {
      data[i] = 255; // R
      data[i + 1] = 255; // G
      data[i + 2] = 255; // B
      data[i + 3] = 0; // A
    }
  }
  return data;
};

export const getImageDataFromImg = (
  imageOrCanvas,
  smoothPercentage = 0,
  binarize_threshold = 0.01
) => {
  const tempCanvas = document.createElement("canvas");
  const minSize = Math.min(imageOrCanvas.width, imageOrCanvas.height);
  const blurAmount = Math.ceil(minSize * (smoothPercentage / 100));

  StackBlur.image(imageOrCanvas, tempCanvas, blurAmount, true);
  const ctx = tempCanvas.getContext("2d");
  if (!ctx) {
    throw new Error("Failed to get 2D context");
  }

  // 이미지 데이터 alpha 컷으로 이진화
  const imageData = ctx.getImageData(
    0,
    0,
    imageOrCanvas.width,
    imageOrCanvas.height
  );
  binarizeImageData(imageData.data, binarize_threshold);
  return imageData;
};

export const drawRaster = (paper_scope, image, opacity) => {
  const raster = new paper.Raster(image);
  raster.name = "image";
  raster.locked = true;
  raster.opacity = opacity;
  raster.visible = true;
  raster.selected = false;
  raster.position = paper_scope.view.center;
  raster.scale(1);
  return raster;
};

export const loadImage = async (url) => {
  const image = new Image();
  image.crossOrigin = "Anonymous";
  image.src = url;
  return new Promise((resolve, reject) => {
    image.onload = () => resolve(image);
    image.onerror = (e) => reject(e);
  });
};

export const addEventPathMove = (paper_scope, test_paths_arr) => {
  const tool = new paper_scope.Tool();

  let hit_path;
  const hit_opts = {
    // segments: true,
    stroke: true,
    fill: true,
    match: (item) => item.item.name === "as-is",

    tolerance:
      ((paper_scope.view.size.width + paper_scope.view.size.height) / 2) * 0.01,
  };
  tool.onMouseDown = (e) => {
    const hit_result = paper_scope.project.activeLayer.hitTest(
      e.point,
      hit_opts
    );
    if (hit_result) {
      hit_path = hit_result.item;
    }
  };
  tool.onMouseDrag = (e) => {
    if (hit_path) {
      hit_path.translate(e.delta);
      hit_path.data.offset_path.translate(e.delta);
    }
  };
  tool.onMouseUp = () => {
    const test_paths_str = go(
      test_paths_arr.splice(1),
      map((path) => path.data.as_is_path.pathData)
    );
    // console.log(test_paths_str);

    const collision_check_item = checkPathsCollision(
      test_paths_str,
      "0 0 600 600",
      15,
      false
    );
    const check_result = [
      collision_check_item.is_artboard_collision,
      ...collision_check_item.is_paths_collision,
    ];

    go(
      zipL(check_result, collision_check_item.test_paths_arr),
      eachL(([is_collide, path]) => {
        path.set({
          strokeColor: is_collide ? "red" : "black",
        });
      }),
      takeAll
    );
    hit_path = null;
  };
};

export const getRectPathbyPosition = (
  paper_scope,
  position_obj_xywh,
  is_insert
) => {
  const { x, y, w, h } = position_obj_xywh;
  return new paper_scope.Path({
    segments: [
      [x, y],
      [x + w, y],
      [x + w, y + h],
      [x, y + h],
    ],
    insert: is_insert,
    closed: true,
  });
};

export const getAllSegmentsCounts = (path) => {
  let counts;

  if (path instanceof paper.CompoundPath) {
    counts = go(
      path.children,
      sumBy(({ segments }) => segments.length)
    );
  } else {
    counts = path.segments.length;
  }
  return counts;
};

export const countsAllPathSegments = ({ paper_scope }) => {
  return go(
    paper_scope.project.activeLayer.getItems({ class: paper_scope.Path }),
    sumBy(({ segments }) => segments.length)
  );
};

// 다운로드 함수
export const downloadCanvas = (canvas, fileName = "blurred_image.png") => {
  // PNG 형식으로 변환
  const imageData = canvas.toDataURL("image/png");

  // 다운로드 링크 생성 및 클릭
  const link = document.createElement("a");
  link.href = imageData;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const canvasToImage = (canvas, imageFormat = "image/png") => {
  return new Promise((resolve, reject) => {
    const image = new Image();

    image.onload = () => resolve(image);
    image.onerror = (error) => reject(error);

    // canvas를 base64 데이터 URL로 변환
    image.src = canvas.toDataURL(imageFormat);
  });
};

export const imageDataToImage = (imageData, options = {}) => {
  const {
    imageFormat = "image/png",
    quality = 1.0,
    imageSmoothingQuality = "high",
  } = options;

  return new Promise((resolve, reject) => {
    try {
      // 임시 캔버스 생성
      const canvas = document.createElement("canvas");
      canvas.width = imageData.width;
      canvas.height = imageData.height;
      const ctx = canvas.getContext("2d", { willReadFrequently: true });

      // ImageData를 캔버스에 그리기
      ctx.putImageData(imageData, 0, 0);

      // 새로운 Image 객체 생성
      const image = new Image();

      // 이벤트 핸들러 설정
      image.onload = () => resolve(image);
      image.onerror = (error) => reject(error);

      // 캔버스를 Data URL로 변환하여 이미지 소스로 설정
      image.src = canvas.toDataURL(imageFormat, quality);
    } catch (error) {
      reject(error);
    }
  });
};

export const downloadImageData = (imageData, options = {}) => {
  const {
    fileName = "image.png",
    imageFormat = "image/png",
    quality = 1.0,
  } = options;

  // 임시 캔버스 생성
  const canvas = document.createElement("canvas");
  canvas.width = imageData.width;
  canvas.height = imageData.height;
  const ctx = canvas.getContext("2d", { willReadFrequently: true });

  // ImageData를 캔버스에 그리기
  ctx.putImageData(imageData, 0, 0);

  // Canvas를 data URL로 변환
  const dataUrl = canvas.toDataURL(imageFormat, quality);

  // 다운로드 링크 생성 및 클릭
  const link = document.createElement("a");
  link.href = dataUrl;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  // 메모리 정리
  canvas.width = 0;
  canvas.height = 0;
};
